import classes from './badge.module.css'

const Badge = {
  classNames: {
    section: classes.section,
  },
}

export default Badge
